/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import { Typography2 } from '@coursera/cds-core';
import { ShareIcon } from '@coursera/cds-icons';

import _t from 'i18n!nls/sharing-common';

const styles = {
  container: css`
    padding: var(--cds-spacing-100);
    display: inline-flex;
    align-items: center;
    justify-content: center;
    text-decoration: none;
    background-color: transparent;
    border-radius: var(--cds-border-radius-50);
    color: var(--cds-color-interactive-primary);

    &:hover {
      background-color: var(--cds-color-blue-25);
    }

    &:hover .text-label {
      text-decoration: underline;
    }
  `,

  iconWrapper: css`
    display: inline-flex;
    align-items: center;
    margin-right: 8px;
  `,

  labelWrapper: css`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    text-transform: none;
  `,
};

type Props = {
  isDark?: boolean;
  buttonText?: string;
};

const ShareCTAV2 = ({ buttonText, isDark }: Props) => {
  const svgColor = isDark ? '#FFFFFF' : '#0056D2';

  return (
    <div data-testid="ShareCTAV2" className="rc-ShareCTAV2" css={styles.container}>
      <span css={styles.labelWrapper}>
        <span css={styles.iconWrapper}>
          <ShareIcon size="small" stroke={svgColor} strokeWidth=".25" />
        </span>
        <Typography2 className="text-label" variant="actionSecondary" component="a">
          {buttonText || _t('Share')}
        </Typography2>
      </span>
    </div>
  );
};

export default ShareCTAV2;
